<template>
  <div v-if="visible" class="transfer-overlay" @click.self="handleClose">
    <div class="transfer-dialog">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>
      
      <!-- 标题 -->
      <div class="dialog-header">
        <h2 class="dialog-title">{{ $t('transfer.title') || '账户划转' }}</h2>
      </div>
      
      <!-- 内容 -->
      <div class="dialog-content">
        <AccountTransfer :showHistory="true" @transfer-success="handleTransferSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import AccountTransfer from '@/components/AccountTransfer.vue';

export default {
  name: 'TransferDialog',
  components: {
    AccountTransfer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    
    handleTransferSuccess() {
      // 划转成功后可以触发父组件刷新余额等操作
      this.$emit('transfer-success');
    }
  }
};
</script>

<style scoped>
/* 遮罩层 */
.transfer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: all 0.3s ease;
}

/* 弹窗容器 */
.transfer-dialog {
  width: 1000px;
  max-width: 95vw;
  max-height: 90vh;
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  position: relative;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.close-btn i {
  font-size: 18px;
}

/* 标题区域 */
.dialog-header {
  padding: 30px 40px 0;
  text-align: center;
}

.dialog-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  transition: color 0.3s ease;
}

/* 内容区域 */
.dialog-content {
  padding: 10px 20px 40px;
}

/* 滚动条样式 */
.transfer-dialog::-webkit-scrollbar {
  width: 6px;
}

.transfer-dialog::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 3px;
}

.transfer-dialog::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 3px;
}

.transfer-dialog::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* 响应式 */
@media (max-width: 768px) {
  .transfer-dialog {
    width: 95vw;
  }
  
  .dialog-header {
    padding: 20px 20px 0;
  }
  
  .dialog-title {
    font-size: 20px;
  }
  
  .dialog-content {
    padding: 10px 0 20px;
  }
}
</style>

